import { render, staticRenderFns } from "./User_New.vue?vue&type=template&id=23a94d6e&"
import script from "./User_New.vue?vue&type=script&lang=js&"
export * from "./User_New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports